import React from 'react';
import { Check, X } from 'lucide-react';
import { HUNTR_OLD_WAY, HUNTR_NEW_WAY } from '@/data/huntr';

export default function HuntrCompare() {
  return (
    <section className="bg-[#0B0B0B] border-t border-white/10 py-16 lg:py-24">
      <div className="max-w-[1320px] mx-auto px-6 lg:px-10">
        <p className="text-[10px] uppercase tracking-[0.2em] text-[#3B82F6]">The Economics</p>
        <h2 className="mt-4 font-display font-bold text-white text-3xl lg:text-[2.75rem] tracking-tight max-w-3xl leading-tight">
          One SDR costs more and delivers less.
        </h2>

        <div className="mt-12 grid lg:grid-cols-2 gap-5">
          <div className="rounded-2xl border border-white/10 bg-white/[0.02] p-7 lg:p-9">
            <h3 className="font-display font-semibold text-white/70 text-lg">Building it in-house</h3>
            <ul className="mt-6 space-y-4">
              {HUNTR_OLD_WAY.map((t) => (
                <li key={t} className="flex gap-3 text-sm text-white/45 leading-relaxed">
                  <X className="w-4 h-4 text-white/25 shrink-0 mt-0.5" />
                  {t}
                </li>
              ))}
            </ul>
          </div>

          <div className="rounded-2xl border border-[#3B82F6]/40 bg-[#2563EB]/[0.07] p-7 lg:p-9">
            <h3 className="font-display font-semibold text-white text-lg">Running Huntr</h3>
            <ul className="mt-6 space-y-4">
              {HUNTR_NEW_WAY.map((t) => (
                <li key={t} className="flex gap-3 text-sm text-white/75 leading-relaxed">
                  <Check className="w-4 h-4 text-[#3B82F6] shrink-0 mt-0.5" />
                  {t}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}